import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "filter-container filters" }
const _hoisted_3 = { class: "dataTable" }
const _hoisted_4 = { class: "titlePreavis" }
const _hoisted_5 = {
  key: 1,
  class: "datatable-container"
}
const _hoisted_6 = { class: "actions-bar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Filter = _resolveComponent("Filter")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!
  const _component_ModalCard = _resolveComponent("ModalCard")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.visible)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        onCancel: _ctx.onCancel
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ModalCard, {
            "active-validate": false,
            "content-max-height": _ctx.contentMaxHeight,
            headerTitle: _ctx.title,
            height: _ctx.height,
            "max-width": _ctx.maxWidth,
            width: _ctx.width,
            withoutBotNav: true,
            onCancel: _ctx.onCancel
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_Filter, {
                    equipementList: _ctx.equipementList,
                    filter: _ctx.filter,
                    searchSite: _ctx.searchSite,
                    siteList: _ctx.siteList,
                    siteListTotal: _ctx.siteListTotal,
                    class: "filter",
                    onAddFilterEquipement: _ctx.addFilterEquipement,
                    onAddFilterSite: _ctx.addFilterSite,
                    onClearFilter: _ctx.clearFilter,
                    onEquipementToggleSelectAll: _ctx.equipementToggleSelectAll,
                    onMultipleSelectSearchSite: _ctx.multipleSelectSearchSite,
                    onRemoveFilterEquipement: _ctx.removeFilterEquipement,
                    onRemoveFilterSite: _ctx.removeFilterSite,
                    onSearch: _ctx.search,
                    onSiteToggleSelectAll: _ctx.siteToggleSelectAll
                  }, null, 8, ["equipementList", "filter", "searchSite", "siteList", "siteListTotal", "onAddFilterEquipement", "onAddFilterSite", "onClearFilter", "onEquipementToggleSelectAll", "onMultipleSelectSearchSite", "onRemoveFilterEquipement", "onRemoveFilterSite", "onSearch", "onSiteToggleSelectAll"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("h2", null, [
                      _createTextVNode(_toDisplayString(_ctx.count) + " " + _toDisplayString(_ctx.$tc('preavisIntervention.preavis', _ctx.count)) + " ", 1),
                      _createVNode(_component_ReglePastille, { cle: "preavisIntervention.definition" }),
                      _createVNode(_component_ReglePastille, { cle: "preavisIntervention.portee" })
                    ])
                  ]),
                  (_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_LoaderComponent, {
                        key: 0,
                        class: "loader"
                      }))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_DataTable, {
                          count: _ctx.count,
                          isLoading: _ctx.isLoading,
                          "not-sticky": true,
                          "stop-propa-on-pdf": true,
                          tableData: _ctx.tableData,
                          tableHeader: _ctx.tableHeader,
                          onDelete: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onDelete($event))),
                          onEdit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onEdit($event))),
                          onSort: _cache[2] || (_cache[2] = ($event: any) => (_ctx.doSort($event))),
                          onToggleActif: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onToggleActif($event)))
                        }, null, 8, ["count", "isLoading", "tableData", "tableHeader"])
                      ]))
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_ButtonBlue, {
                    "on-click": _ctx.openCreate,
                    text: _ctx.$t('modale.preavisIntervention.button.create'),
                    class: "button-create btn"
                  }, null, 8, ["on-click", "text"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["content-max-height", "headerTitle", "height", "max-width", "width", "onCancel"])
        ]),
        _: 1
      }, 8, ["onCancel"]))
    : _createCommentVNode("", true)
}